const groupPrefix = 'segments'

export const apiUpsells = {
	fetchSegmentUpsells: async (segmentID: number, page = 1, perPage = 10, filters?: { id: string; value: any }[]) => {
		let url = `${groupPrefix}/${segmentID}/upsells`
		const queryParams = []

		queryParams.push(`per_page=${perPage}`)
		queryParams.push(`page=${page}`)

		const filterQueries: string[] = []

		filters?.forEach((filter) => {
			filterQueries.push(`filter[${filter.id}]=${filter.value}`)
		})

		if (filterQueries && filterQueries.length > 0) {
			filterQueries.forEach((query) => {
				queryParams.push(query)
			})
		}

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data } = await apiCommon<ISegmentUpsell>(url, {
			method: 'GET',
		})

		return UpsellProduct(data)
	},

	updateSegmentUpsell: async (segmentID: number, upsellIDs: number) => {
		const { data } = await apiCommon<ISegmentUpsell>(`${groupPrefix}/${segmentID}/upsells`, {
			method: 'POST',
			body: { upsells: upsellIDs },
		})
		return UpsellProduct(data)
	},

	// deleteProductUpsell: async (upsellID: string) => {
	// 	const data = await apiCommon<string>(`${groupPrefixUpsell}/${upsellID}`, { method: 'DELETE' })
	// 	return data
	// },
}
